// modules
import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setDetailedList, setSummaryList } from 'src/store/modules/reports'

import {
  DATE_TIME_FORMAT_FOR_SERVER,
  EXPORT_CASE_MANAGER_CENSUS_DETAILED_REPORT,
  EXPORT_CASE_MANAGER_CENSUS_SUMMARY_REPORT,
  GET_CASE_MANAGER_CENSUS_DETAILED,
  GET_CASE_MANAGER_CENSUS_SUMMARY
} from 'src/constants'
import { exportReport } from 'src/utils/Functions'

export const fetchCaseManagerCensus =
  (config = {}, isDetailedReport = false) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: isDetailedReport
            ? GET_CASE_MANAGER_CENSUS_DETAILED
            : GET_CASE_MANAGER_CENSUS_SUMMARY,
          params,
          query
        }
      })

      if (isDetailedReport) {
        dispatch(setSummaryList([]))
        dispatch(setDetailedList(items))
      } else {
        dispatch(setSummaryList(items))
        dispatch(setDetailedList([]))
      }

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const exportCaseManagerCensusReport =
  (config = {}, isDetailedReport = false) =>
  async () => {
    const updConfig = {
      ...config,
      pathname: isDetailedReport
        ? EXPORT_CASE_MANAGER_CENSUS_DETAILED_REPORT
        : EXPORT_CASE_MANAGER_CENSUS_SUMMARY_REPORT
    }
    const fileNameDefault = `case_manager_census_report_${moment().format(
      DATE_TIME_FORMAT_FOR_SERVER
    )}.xls`

    await exportReport(updConfig, fileNameDefault)
  }
